module.exports = __webpack_public_path__ + "static/Grafika9-c56e0bad0d6358ff37bff9ab139674b5.png";